// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__7i596","title":"AfterFrontImage_title__2C77Y"};